// @flow
import type { FSA } from 'types/redux';
import _ from 'lodash';

import * as RequestResultCases from 'middlewares/api-middleware';
import * as Actions from 'actions/user';
import { saveAuthCookie, removeAuthCookie } from 'utils/user-utils';
import jwtDecode from 'jwt-decode';
import * as Sentry from 'utils/sentry.js';

export type UserState = {
  name?: string,
  email?: string,
  accessToken?: string,
  refreshToken?: string,
  relogin?: boolean,
  userPermissions?: Object,
};

export function defaultUserState(): UserState {
  return {};
}

export function user(
  state: UserState = defaultUserState(),
  action: FSA,
): UserState {
  switch (action.type) {
    case Actions.USER_LOGOUT:
      removeAuthCookie();
      return defaultUserState();
    case Actions.FORCE_RELOGIN:
      removeAuthCookie();
      return {
        ...defaultUserState(),
        relogin: true,
      };
    case Actions.REFRESH_TOKEN + RequestResultCases.SUCCESS:
      saveAuthCookie(action.payload.jwtToken);
      return {
        ...state,
        accessToken: action.payload.jwtToken || '',
      };
    case Actions.REFRESH_TOKEN + RequestResultCases.FAILURE:
      removeAuthCookie();
      return {
        ...defaultUserState(),
        relogin: true,
      };
    case Actions.GRAB_LOGIN + RequestResultCases.FAILURE:
      if (!action.meta) {
        return state;
      }

      return {
        ...state,
        name: action.meta.name,
        email: action.meta.email,
      };
    case Actions.COOKIE_LOGIN:
    case Actions.GRAB_LOGIN + RequestResultCases.SUCCESS:
    case Actions.GOOGLE_LOGIN + RequestResultCases.SUCCESS: {
      if (!action.meta) {
        return state;
      }

      const { jwt, refreshToken } = action.payload;
      const jwtData = jwtDecode(jwt);
      saveAuthCookie(jwt, refreshToken, window.Grab.config.AUTH_TYPE);
      const email = _.get(action, 'meta.email') || _.get(jwtData, 'email') || _.get(jwtData, 'name');
      Sentry.setUserInfo({ email });
      return {
        ...state,
        relogin: false,
        name: _.get(action, 'meta.name') || _.get(jwtData, 'name'),
        email,
        accessToken: jwt || '',
        refreshToken: refreshToken || '',
      };
    }

    case Actions.GET_USER_PERMISSIONS + RequestResultCases.SUCCESS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    default:
      return state;
  }
}

export default user;
